import { useMutation } from "@tanstack/react-query";
import { Button } from "components/Atoms/Button";
import LabelledDivRow from "components/LabelledDivRow";
import { SomethingUnexpectedHappenedMessageBox } from "components/MessageBox/SomethingUnexpectedHappenedMessageBox";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import ValidatorContext from "formvalidation/FormContext";
import { useValidators } from "formvalidation/hooks";
import React from "react";

interface Props {
  editingProject: server.dto.BusinessCentralProject;
  onSaved: () => void
}

const EditBusinessCentralProjectModalContent = (props: Props) => {
  const [displayName, setDisplayName] = React.useState(props.editingProject.name);

  const validators = useValidators();

  const addProjectMutation = useMutation(window.CoreApi.BusinessCentral.UpdateProject);

  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const validatorResult = await validators.validateAll();
    if (validatorResult.hasErrors) {
      return;
    }

    const res = await addProjectMutation.mutateAsync({
      code: props.editingProject.number,
      displayName,
      blocked: !props.editingProject.visible
    });

    if (!res.data.hasErrors) {
      props.onSaved();
    }
  };

  return <ValidatorContext settings={validators.validatorSettings}>
    <form className="flex-column gap" onSubmit={onSubmit}>
      <div className="gray-100 padding-large flex-column gap">
        <LabelledDivRow label={RESX.GeneralLabels.Name}>
          <RequiredTextInput validatorKey="displayName" value={displayName} onChange={setDisplayName} maxLength={serverReference.constants.businessCentral.maxProjectDisplayNameLength} />
        </LabelledDivRow>
        <LabelledDivRow label={RESX.Planning.Code}>
          <div>{props.editingProject.number}</div>
        </LabelledDivRow>
      </div>

      {addProjectMutation.data?.data.hasErrors && <div className="message ui red">
        {addProjectMutation.data.data.errors.map((error, i) => <div key={i}>{error.message}</div>)}
      </div>}
      {addProjectMutation.isError && <SomethingUnexpectedHappenedMessageBox />}

      <div className="flex justify-end">
        <Button disabled={addProjectMutation.isLoading} loading={addProjectMutation.isLoading} type="primary" htmlType="submit" label={RESX.Buttons.btnSave} />
      </div>
    </form>
  </ValidatorContext>;
};

export default EditBusinessCentralProjectModalContent;